// import { apiUrls } from "../../../constants";
// import apiRequest from "../../apiRequest";

// async function getCategoryId(slug) {
//   const response = await apiRequest({
//     url: `${apiUrls.categories}?per_page=50`,
//     method: "GET",
//     data: undefined,
//   });
//   const category = response?.data.find((cat) => cat.slug === slug);
//   return category ? category.id : null;
// }

// // Updated getPosts function
// export async function getPosts(slug) {
//   const categoryId = await getCategoryId(slug);
//   if (categoryId) {
//     return apiRequest({
//       url: `${apiUrls.posts}?categories=${categoryId}&_embed&orderby=date&order=asc&per_page=50`,
//       method: "GET",
//       data: undefined,
//     });
//   } else {
//     return {
//       success: false,
//       data: [],
//     };
//     // throw new Error("Blog category not found");
//   }
// }

// export async function getAchievements(slug) {
//   const categoryId = await getCategoryId(slug);
//   if (categoryId) {
//     return apiRequest({
//       url: `${apiUrls.posts}?categories=${categoryId}&_embed&orderby=date&order=asc&per_page=50&_=${new Date().getTime()}`,
//       method: "GET",
//       data: undefined,
//     });
//   } else {
//     return {
//       success: false,
//       data: [],
//     };
//     // throw new Error("Blog category not found");
//   }
// }

// export async function getCategories(slug) {
//   const categoryId = await getCategoryId(slug);
//   const response = await apiRequest({
//     url: `${apiUrls.categories}?per_page=50&parent=${categoryId}`,
//     method: "GET",
//     data: undefined,
//   });
//   const categoryNames = response?.data.map(category => ({ name: category.name, slug: category.slug }));
//   return categoryNames;
// }

// export async function getPostDetail(id) {
//   const response = apiRequest({
//     url: `${apiUrls.posts}/?search=${encodeURIComponent(id)}`,
//     method: "GET",
//     data: undefined,
//   });
//   return response;
// }


// import { apiUrls } from "../../../constants";
// import apiRequest from "../../apiRequest";

// // 🔥 Cache for category mapping (slug → id)
// let categoryCache = null;

// // ✅ Fetch and cache category map
// async function getCategoryMap() {
//   if (categoryCache) return categoryCache;

//   const response = await apiRequest({
//     url: `${apiUrls.categories}?_fields=id,slug&per_page=100`,
//     method: "GET",
//   });

//   const map = {};
//   response?.data.forEach((cat) => {
//     map[cat.slug] = cat.id;
//   });

//   categoryCache = map;
//   return map;
// }

// // ✅ Get category ID from slug (cached)
// async function getCategoryId(slug) {
//   const map = await getCategoryMap();

//   console.log("Category Map:", map); // debug once

//   return map[slug?.toLowerCase()] || null;
// }

// // 🚀 Optimized getPosts
// export async function getPosts(slug) {
//   const categoryId = await getCategoryId(slug);

//   if (!categoryId) {
//     return { success: false, data: [] };
//   }

//   const response = await apiRequest({
//     url: `${apiUrls.posts}?categories=${categoryId}&_embed=wp:featuredmedia,wp:term&_fields=id,title,excerpt,date,_embedded&orderby=date&order=asc&per_page=10`,
//     method: "GET",
//   });

//   // 🔥 Normalize response to OLD structure
//   const normalizedData = response.data.map((post) => ({
//     ...post,
//     title: { rendered: post.title?.rendered || post.title },
//     excerpt: { rendered: post.excerpt?.rendered || post.excerpt },
//     _embedded: post._embedded || {},
//   }));

//   return {
//     ...response,
//     data: normalizedData,
//   };
// }

// // 🚀 Optimized getAchievements (removed cache buster)
// export async function getAchievements(slug) {
//   const categoryId = await getCategoryId(slug);

//   if (!categoryId) {
//     return { success: false, data: [] };
//   }

//   const response = await apiRequest({
//     url: `${apiUrls.posts}?categories=${categoryId}&_embed=wp:featuredmedia,wp:term&_fields=id,title,excerpt,date,_embedded&orderby=date&order=asc&per_page=10`,
//     method: "GET",
//   });

//   const normalizedData = response.data.map((post) => ({
//     ...post,
//     title: { rendered: post.title?.rendered || post.title },
//     excerpt: { rendered: post.excerpt?.rendered || post.excerpt },
//     _embedded: post._embedded || {},
//   }));

//   return {
//     ...response,
//     data: normalizedData,
//   };
// }

// // 🚀 Optimized getCategories (child categories)
// export async function getCategories(slug) {
//   const categoryId = await getCategoryId(slug);

//   if (!categoryId) return [];

//   const response = await apiRequest({
//     url: `${apiUrls.categories}?parent=${categoryId}&_fields=id,name,slug`,
//     method: "GET",
//   });

//   return response?.data.map((cat) => ({
//     name: cat.name,
//     slug: cat.slug,
//   }));
// }

// // 🚀 Optimized getPostDetail
// export async function getPostDetail(id) {
//   const response = await apiRequest({
//     url: `${apiUrls.posts}/${id}?_embed=wp:featuredmedia,wp:term`,
//     method: "GET",
//   });

//   const post = response.data;

//   const normalizedPost = {
//     ...post,
//     title: { rendered: post.title?.rendered || post.title },
//     content: { rendered: post.content?.rendered || post.content },
//     excerpt: { rendered: post.excerpt?.rendered || post.excerpt },
//     _embedded: post._embedded || {},
//   };

//   return {
//     ...response,
//     data: [normalizedPost], // keep old array format
//   };
// }


// import { apiUrls } from "../../../constants";
// import apiRequest from "../../apiRequest";

// // 🔥 ADD THIS (cache)
// let categoryCache = null;

// async function getCategoryId(slug) {
//   // ✅ Use cache instead of calling API every time
//   if (!categoryCache) {
//     const response = await apiRequest({
//       url: `${apiUrls.categories}?per_page=50`,
//       method: "GET",
//       data: undefined,
//     });

//     categoryCache = response?.data || [];
//   }

//   const category = categoryCache.find((cat) => cat.slug === slug);
//   return category ? category.id : null;
// }

// // ✅ Updated getPosts (only per_page changed)
// export async function getPosts(slug) {
//   const categoryId = await getCategoryId(slug);

//   if (categoryId) {
//     return apiRequest({
//       url: `${apiUrls.posts}?categories=${categoryId}&_embed&orderby=date&order=asc&per_page=50`, // 🔥 50 → 10
//       method: "GET",
//       data: undefined,
//     });
//   } else {
//     return {
//       success: false,
//       data: [],
//     };
//   }
// }

// export async function getAchievements(slug) {
//   const categoryId = await getCategoryId(slug);

//   if (categoryId) {
//     return apiRequest({
//       url: `${apiUrls.posts}?categories=${categoryId}&_embed&orderby=date&order=asc&per_page=50&_=${new Date().getTime()}`, // 🔥 50 → 10
//       method: "GET",
//       data: undefined,
//     });
//   } else {
//     return {
//       success: false,
//       data: [],
//     };
//   }
// }

// export async function getCategories(slug) {
//   const categoryId = await getCategoryId(slug);

//   if (!categoryId) return [];

//   const response = await apiRequest({
//     url: `${apiUrls.categories}?per_page=50&parent=${categoryId}`,
//     method: "GET",
//     data: undefined,
//   });

//   return response?.data.map((category) => ({
//     name: category.name,
//     slug: category.slug,
//   }));
// }

// // 🔥 Keep OLD logic (no change to avoid breaking UI)
// export async function getPostDetail(id) {
//   const response = apiRequest({
//     url: `${apiUrls.posts}/?search=${encodeURIComponent(id)}`,
//     method: "GET",
//     data: undefined,
//   });
//   return response;
// }

import { apiUrls } from "../../../constants";
import apiRequest from "../../apiRequest";

// 🔥 GLOBAL CACHE + PROMISE (prevents duplicate parallel calls)
let categoryCache = null;
let categoryPromise = null;

// ✅ Fetch categories ONLY ONCE
async function fetchCategories() {
  if (categoryCache) return categoryCache;

  // 🔥 Prevent multiple API calls during initial load
  if (!categoryPromise) {
    categoryPromise = apiRequest({
      url: `${apiUrls.categories}?per_page=50`,
      method: "GET",
    }).then((response) => {
      categoryCache = response?.data || [];
      return categoryCache;
    });
  }

  return categoryPromise;
}

// ✅ Get category ID using cached data
async function getCategoryId(slug) {
  const categories = await fetchCategories();

  const category = categories.find((cat) => cat.slug === slug);
  return category ? category.id : null;
}

// ✅ Get Posts
export async function getPosts(slug, limit = 6) {
  const categoryId = await getCategoryId(slug);

  if (categoryId) {
    return apiRequest({
      url: `${apiUrls.posts}?categories=${categoryId}&_embed&orderby=date&order=desc&per_page=${limit}`,
      method: "GET",
    });
  } else {
    return {
      success: false,
      data: [],
    };
  }
}

// ✅ Get Achievements (no duplicate category call now)
export async function getAchievements(slug, limit = 6) {
  const categoryId = await getCategoryId(slug);

  if (categoryId) {
    return apiRequest({
      url: `${apiUrls.posts}?categories=${categoryId}&_embed&orderby=date&order=desc&per_page=${limit}&_=${new Date().getTime()}`,
      method: "GET",
    });
  } else {
    return {
      success: false,
      data: [],
    };
  }
}

// ✅ Get Sub Categories (ONLY child API call happens)
export async function getCategories(slug) {
  const categories = await fetchCategories(); // ✅ reuse cache

  const parentCategory = categories.find((cat) => cat.slug === slug);
  if (!parentCategory) return [];

  const response = await apiRequest({
    url: `${apiUrls.categories}?per_page=50&parent=${parentCategory.id}`,
    method: "GET",
  });

  return response?.data.map((category) => ({
    name: category.name,
    slug: category.slug,
  }));
}

// ✅ Keep OLD logic (unchanged)
export async function getPostDetail(id) {
  return apiRequest({
    url: `${apiUrls.posts}/?search=${encodeURIComponent(id)}`,
    method: "GET",
  });
}